/**
 * @generated SignedSource<<aeed16923b021d4cf7f5117fd873ed7c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraNavigationItemTypeKey = "APP" | "APPROVALS" | "APPS" | "ARCHIVED_ISSUES" | "ATTACHMENTS" | "BACKLOG" | "BOARD" | "CALENDAR" | "CAPACITY" | "CODE" | "COMPONENTS" | "CUSTOMER_SUPPORT" | "DEPENDENCIES" | "DEPLOYMENTS" | "DEVELOPMENT" | "FORMS" | "GET_STARTED" | "GOALS" | "INBOX" | "INCIDENTS" | "ISSUES" | "LIST" | "ON_CALL" | "PAGES" | "PLAN_CALENDAR" | "PLAN_DEPENDENCIES" | "PLAN_PROGRAM" | "PLAN_RELEASES" | "PLAN_SUMMARY" | "PLAN_TEAMS" | "PLAN_TIMELINE" | "PROGRAM" | "QUEUE" | "RELEASES" | "REPORTS" | "REQUESTS" | "SECURITY" | "SHORTCUTS" | "STAFFING" | "SUMMARY" | "TEAMS" | "TIMELINE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type TabMenu_tab$data = {
  readonly __id: string;
  readonly appId?: string | null | undefined;
  readonly canRemove: boolean | null | undefined;
  readonly canRename: boolean | null | undefined;
  readonly canSetAsDefault: boolean | null | undefined;
  readonly id: string;
  readonly isDefault: boolean;
  readonly typeKey: JiraNavigationItemTypeKey;
  readonly " $fragmentSpreads": FragmentRefs<"HideItem_tab" | "MoveItem_tab" | "SetAsDefaultItem_tab">;
  readonly " $fragmentType": "TabMenu_tab";
};
export type TabMenu_tab$key = {
  readonly " $data"?: TabMenu_tab$data;
  readonly " $fragmentSpreads": FragmentRefs<"TabMenu_tab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "TabMenu_tab",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SetAsDefaultItem_tab"
    },
    {
      "kind": "FragmentSpread",
      "name": "MoveItem_tab"
    },
    {
      "kind": "FragmentSpread",
      "name": "HideItem_tab"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "typeKey"
      },
      "action": "THROW",
      "path": "typeKey"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "isDefault"
      },
      "action": "THROW",
      "path": "isDefault"
    },
    {
      "kind": "ScalarField",
      "name": "canRename"
    },
    {
      "kind": "ScalarField",
      "name": "canRemove"
    },
    {
      "kind": "ScalarField",
      "name": "canSetAsDefault"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "appId"
        }
      ],
      "type": "JiraAppNavigationItem"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "c39dc9c76de61cd2fa1248c73d2f808d";

export default node;
